import { useState } from "react";
import { BookOpen, Presentation } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { adminApi } from "@/lib/api";
import { SEMINAR } from "@/seminars";

const GUIDES = [
  { kind: "deck", label: "Slides", file: `${SEMINAR.admin.tag}-Webinar-Team-Guide.pptx`, Icon: Presentation, title: "Download the team presentation (PowerPoint)" },
  { kind: "handbook", label: "Handbook", file: `${SEMINAR.admin.tag}-Webinar-Team-Handbook.pdf`, Icon: BookOpen, title: "Download the step-by-step handbook (PDF)" },
];

export function GuideDownloads() {
  const [busy, setBusy] = useState("");
  if (!SEMINAR.guide) return null;
  const enabled = SEMINAR.guide === true ? { deck: true, handbook: true } : SEMINAR.guide;
  const guides = GUIDES.filter((guide) => enabled[guide.kind]);
  if (!guides.length) return null;

  const download = async ({ kind, file }) => {
    setBusy(kind);
    try {
      const { data } = await adminApi.get(`/admin/guide/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = file;
      a.click();
      URL.revokeObjectURL(url);
    } catch (_) {
      toast.error("Download failed. Please try again");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="hidden items-center gap-1 rounded-full border border-white/10 bg-white/[0.04] p-1 md:flex" data-testid="team-guide-downloads">
      <span className="pl-2 pr-1 text-[10px] font-bold uppercase tracking-wider text-[#f2d28f]/80">Team guide</span>
      {guides.map((guide) => (
        <Button key={guide.kind} variant="ghost" size="sm" disabled={busy === guide.kind} onClick={() => download(guide)} title={guide.title} className="h-7 rounded-full px-2.5 text-[11px] font-semibold text-white/75 hover:bg-[#f2d28f] hover:text-[#07130f]" data-testid={`guide-download-${guide.kind}`}>
          <guide.Icon className="mr-1 h-3.5 w-3.5" /> {busy === guide.kind ? "…" : guide.label}
        </Button>
      ))}
    </div>
  );
}
